import ECDN10Playback from '../../ecdn10/Playback';
import ECDN11Playback from '../../ecdn11/Playback';
import { DeliveryMode, Playback } from '../../common/constants';
import checkParams from './checkParams';

const { ECDN10, ECDN11, WEBRTC } = DeliveryMode;

const blackoutParams = ['ksdkBlackout'];

type Response = {
  playback: Playback;
  PlaybackModule?: unknown; // typescript doesn't like this union ECDN10Playback | ECDN11Playback;
  reason?: 'ksdkBlackout is true' | 'no.p';
};

export default function getPlaybackModule(mode: DeliveryMode): Response {
  if (checkParams(blackoutParams)) {
    return { playback: Playback.CDN, reason: 'ksdkBlackout is true' };
  }
  switch (mode) {
    case WEBRTC:
    case ECDN11:
      return {
        playback: mode === WEBRTC ? Playback.BBP : Playback.ECDN11,
        PlaybackModule: ECDN11Playback
      };
    case ECDN10:
      return { playback: Playback.ECDN10, PlaybackModule: ECDN10Playback };
    default:
      return { playback: Playback.CDN, reason: 'no.p' };
  }
}
